// extracted by mini-css-extract-plugin
module.exports = {"tourModal":"Tour_tourModal__V2mAi","line":"Tour_line__AXd9x","desc":"Tour_desc__2Z3nb","descDiff":"Tour_descDiff__Pwlpl","footer":"Tour_footer__7BpAj"};